/**
 * Generated by orval 🍺
 * Do not edit manually.
 * API WANGRE
 * API REST de WANGRE, plateforme de gestion de l'Association Monde Rural. JSON snake_case ; erreurs `{ message, code, details | errors }` en français ; montants en chaîne décimale + `currency` ; mises à jour avec `If-Match: <version>` ; créations hors ligne avec `Idempotency-Key`.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptInvitationRequest,
  AuthenticationExceptionResponse,
  ForgotPasswordRequest,
  LoginRequest,
  RegisterRequest,
  ResendInvitationRequest,
  ResendOtpRequest,
  ResetPasswordRequest,
  TwoFactorChallengeRequest,
  TwoFactorResendRequest,
  V1AuthInvitationsAccept200,
  V1AuthInvitationsResend202,
  V1AuthInvitationsShow200,
  V1AuthLogin200,
  V1AuthOtpResend202,
  V1AuthOtpVerify200,
  V1AuthPasswordForgot202,
  V1AuthPasswordPolicy200,
  V1AuthPasswordReset200,
  V1AuthRegister201,
  V1AuthTokensStore200,
  V1AuthTokensStore201,
  V1AuthTwoFactorChallenge200,
  V1AuthTwoFactorResend200,
  ValidationExceptionResponse,
  VerifyOtpRequest
} from '../../model';

import { apiFetch } from '../../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getV1AuthLoginUrl = () => {




  return `/v1/auth/login`
}

/**
 * @summary Connexion web (cookie de session SPA). Identifiant : email, téléphone ou matricule. Vérification en deux étapes
activée (ACC-14) : `two_factor_required` et le défi, sans session ouverte
 */
export const v1AuthLogin = async (loginRequest: LoginRequest, options?: Parameters<typeof apiFetch>[1]): Promise<V1AuthLogin200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<V1AuthLogin200>(getV1AuthLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(loginRequest)
  }
);}





export const getV1AuthLoginMutationKey = () => ['v1AuthLogin'] as const;

export const getV1AuthLoginMutationOptions = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthLogin>>, TError,V1AuthLoginMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AuthLogin>>, TError,V1AuthLoginMutationVariables, TContext> => {

const mutationKey = getV1AuthLoginMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AuthLogin>>, V1AuthLoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  v1AuthLogin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof v1AuthLogin>>>
    export type V1AuthLoginMutationBody = LoginRequest
    export type V1AuthLoginMutationError = ValidationExceptionResponse
    export type V1AuthLoginMutationVariables = {data: LoginRequest}

    /**
 * @summary Connexion web (cookie de session SPA). Identifiant : email, téléphone ou matricule. Vérification en deux étapes
activée (ACC-14) : `two_factor_required` et le défi, sans session ouverte
 */
export const useV1AuthLogin = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthLogin>>, TError,V1AuthLoginMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AuthLogin>>,
        TError,
        V1AuthLoginMutationVariables,
        TContext
      > => {
      return useMutation(getV1AuthLoginMutationOptions(options), queryClient);
    }
    export const getV1AuthTokensStoreUrl = () => {




  return `/v1/auth/tokens`
}

/**
 * @summary Connexion mobile : jeton opaque par appareil (201), ou défi de vérification en deux étapes (200, sans jeton)
 */
export const v1AuthTokensStore = async (loginRequest: LoginRequest, options?: Parameters<typeof apiFetch>[1]): Promise<V1AuthTokensStore200 | V1AuthTokensStore201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<V1AuthTokensStore200 | V1AuthTokensStore201>(getV1AuthTokensStoreUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(loginRequest)
  }
);}





export const getV1AuthTokensStoreMutationKey = () => ['v1AuthTokensStore'] as const;

export const getV1AuthTokensStoreMutationOptions = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthTokensStore>>, TError,V1AuthTokensStoreMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AuthTokensStore>>, TError,V1AuthTokensStoreMutationVariables, TContext> => {

const mutationKey = getV1AuthTokensStoreMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AuthTokensStore>>, V1AuthTokensStoreMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  v1AuthTokensStore(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AuthTokensStoreMutationResult = NonNullable<Awaited<ReturnType<typeof v1AuthTokensStore>>>
    export type V1AuthTokensStoreMutationBody = LoginRequest
    export type V1AuthTokensStoreMutationError = ValidationExceptionResponse
    export type V1AuthTokensStoreMutationVariables = {data: LoginRequest}

    /**
 * @summary Connexion mobile : jeton opaque par appareil (201), ou défi de vérification en deux étapes (200, sans jeton)
 */
export const useV1AuthTokensStore = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthTokensStore>>, TError,V1AuthTokensStoreMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AuthTokensStore>>,
        TError,
        V1AuthTokensStoreMutationVariables,
        TContext
      > => {
      return useMutation(getV1AuthTokensStoreMutationOptions(options), queryClient);
    }
    export const getV1AuthPasswordPolicyUrl = () => {




  return `/v1/auth/password-policy`
}

/**
 * @summary Règles de la politique de mot de passe (ACC-06), affichées en direct
 */
export const v1AuthPasswordPolicy = async ( options?: Parameters<typeof apiFetch>[1]): Promise<V1AuthPasswordPolicy200> => {

  return apiFetch<V1AuthPasswordPolicy200>(getV1AuthPasswordPolicyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1AuthPasswordPolicyQueryKey = () => {
    return [
    `/v1/auth/password-policy`
    ] as const;
    }


export const getV1AuthPasswordPolicyQueryOptions = <TData = Awaited<ReturnType<typeof v1AuthPasswordPolicy>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AuthPasswordPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1AuthPasswordPolicyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1AuthPasswordPolicy>>> = ({ signal }) => v1AuthPasswordPolicy({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1AuthPasswordPolicy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1AuthPasswordPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof v1AuthPasswordPolicy>>>
export type V1AuthPasswordPolicyQueryError = unknown


export function useV1AuthPasswordPolicy<TData = Awaited<ReturnType<typeof v1AuthPasswordPolicy>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AuthPasswordPolicy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AuthPasswordPolicy>>,
          TError,
          Awaited<ReturnType<typeof v1AuthPasswordPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AuthPasswordPolicy<TData = Awaited<ReturnType<typeof v1AuthPasswordPolicy>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AuthPasswordPolicy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AuthPasswordPolicy>>,
          TError,
          Awaited<ReturnType<typeof v1AuthPasswordPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AuthPasswordPolicy<TData = Awaited<ReturnType<typeof v1AuthPasswordPolicy>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AuthPasswordPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Règles de la politique de mot de passe (ACC-06), affichées en direct
 */

export function useV1AuthPasswordPolicy<TData = Awaited<ReturnType<typeof v1AuthPasswordPolicy>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AuthPasswordPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1AuthPasswordPolicyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getV1AuthPasswordForgotUrl = () => {




  return `/v1/auth/password/forgot`
}

/**
 * @summary Mot de passe oublié : code envoyé par email. Réponse identique que le compte existe ou non
 */
export const v1AuthPasswordForgot = async (forgotPasswordRequest: ForgotPasswordRequest, options?: Parameters<typeof apiFetch>[1]): Promise<V1AuthPasswordForgot202> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<V1AuthPasswordForgot202>(getV1AuthPasswordForgotUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(forgotPasswordRequest)
  }
);}





export const getV1AuthPasswordForgotMutationKey = () => ['v1AuthPasswordForgot'] as const;

export const getV1AuthPasswordForgotMutationOptions = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthPasswordForgot>>, TError,V1AuthPasswordForgotMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AuthPasswordForgot>>, TError,V1AuthPasswordForgotMutationVariables, TContext> => {

const mutationKey = getV1AuthPasswordForgotMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AuthPasswordForgot>>, V1AuthPasswordForgotMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  v1AuthPasswordForgot(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AuthPasswordForgotMutationResult = NonNullable<Awaited<ReturnType<typeof v1AuthPasswordForgot>>>
    export type V1AuthPasswordForgotMutationBody = ForgotPasswordRequest
    export type V1AuthPasswordForgotMutationError = ValidationExceptionResponse
    export type V1AuthPasswordForgotMutationVariables = {data: ForgotPasswordRequest}

    /**
 * @summary Mot de passe oublié : code envoyé par email. Réponse identique que le compte existe ou non
 */
export const useV1AuthPasswordForgot = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthPasswordForgot>>, TError,V1AuthPasswordForgotMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AuthPasswordForgot>>,
        TError,
        V1AuthPasswordForgotMutationVariables,
        TContext
      > => {
      return useMutation(getV1AuthPasswordForgotMutationOptions(options), queryClient);
    }
    export const getV1AuthPasswordResetUrl = () => {




  return `/v1/auth/password/reset`
}

/**
 * @summary Nouveau mot de passe avec le code reçu ; toutes les sessions sont fermées
 */
export const v1AuthPasswordReset = async (resetPasswordRequest: ResetPasswordRequest, options?: Parameters<typeof apiFetch>[1]): Promise<V1AuthPasswordReset200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<V1AuthPasswordReset200>(getV1AuthPasswordResetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resetPasswordRequest)
  }
);}





export const getV1AuthPasswordResetMutationKey = () => ['v1AuthPasswordReset'] as const;

export const getV1AuthPasswordResetMutationOptions = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthPasswordReset>>, TError,V1AuthPasswordResetMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AuthPasswordReset>>, TError,V1AuthPasswordResetMutationVariables, TContext> => {

const mutationKey = getV1AuthPasswordResetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AuthPasswordReset>>, V1AuthPasswordResetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  v1AuthPasswordReset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AuthPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof v1AuthPasswordReset>>>
    export type V1AuthPasswordResetMutationBody = ResetPasswordRequest
    export type V1AuthPasswordResetMutationError = ValidationExceptionResponse
    export type V1AuthPasswordResetMutationVariables = {data: ResetPasswordRequest}

    /**
 * @summary Nouveau mot de passe avec le code reçu ; toutes les sessions sont fermées
 */
export const useV1AuthPasswordReset = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthPasswordReset>>, TError,V1AuthPasswordResetMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AuthPasswordReset>>,
        TError,
        V1AuthPasswordResetMutationVariables,
        TContext
      > => {
      return useMutation(getV1AuthPasswordResetMutationOptions(options), queryClient);
    }
    export const getV1AuthRegisterUrl = () => {




  return `/v1/auth/register`
}

/**
 * @summary Auto-inscription d'un public externe (apprenant externe) ; code de vérification envoyé par email
 */
export const v1AuthRegister = async (registerRequest: RegisterRequest, options?: Parameters<typeof apiFetch>[1]): Promise<V1AuthRegister201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<V1AuthRegister201>(getV1AuthRegisterUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(registerRequest)
  }
);}





export const getV1AuthRegisterMutationKey = () => ['v1AuthRegister'] as const;

export const getV1AuthRegisterMutationOptions = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthRegister>>, TError,V1AuthRegisterMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AuthRegister>>, TError,V1AuthRegisterMutationVariables, TContext> => {

const mutationKey = getV1AuthRegisterMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AuthRegister>>, V1AuthRegisterMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  v1AuthRegister(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AuthRegisterMutationResult = NonNullable<Awaited<ReturnType<typeof v1AuthRegister>>>
    export type V1AuthRegisterMutationBody = RegisterRequest
    export type V1AuthRegisterMutationError = ValidationExceptionResponse
    export type V1AuthRegisterMutationVariables = {data: RegisterRequest}

    /**
 * @summary Auto-inscription d'un public externe (apprenant externe) ; code de vérification envoyé par email
 */
export const useV1AuthRegister = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthRegister>>, TError,V1AuthRegisterMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AuthRegister>>,
        TError,
        V1AuthRegisterMutationVariables,
        TContext
      > => {
      return useMutation(getV1AuthRegisterMutationOptions(options), queryClient);
    }
    export const getV1AuthOtpVerifyUrl = () => {




  return `/v1/auth/otp/verify`
}

/**
 * @summary Vérifier le code : le compte est activé puis connecté (session web, ou jeton si `device_name`)
 */
export const v1AuthOtpVerify = async (verifyOtpRequest: VerifyOtpRequest, options?: Parameters<typeof apiFetch>[1]): Promise<V1AuthOtpVerify200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<V1AuthOtpVerify200>(getV1AuthOtpVerifyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(verifyOtpRequest)
  }
);}





export const getV1AuthOtpVerifyMutationKey = () => ['v1AuthOtpVerify'] as const;

export const getV1AuthOtpVerifyMutationOptions = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthOtpVerify>>, TError,V1AuthOtpVerifyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AuthOtpVerify>>, TError,V1AuthOtpVerifyMutationVariables, TContext> => {

const mutationKey = getV1AuthOtpVerifyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AuthOtpVerify>>, V1AuthOtpVerifyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  v1AuthOtpVerify(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AuthOtpVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof v1AuthOtpVerify>>>
    export type V1AuthOtpVerifyMutationBody = VerifyOtpRequest
    export type V1AuthOtpVerifyMutationError = ValidationExceptionResponse
    export type V1AuthOtpVerifyMutationVariables = {data: VerifyOtpRequest}

    /**
 * @summary Vérifier le code : le compte est activé puis connecté (session web, ou jeton si `device_name`)
 */
export const useV1AuthOtpVerify = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthOtpVerify>>, TError,V1AuthOtpVerifyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AuthOtpVerify>>,
        TError,
        V1AuthOtpVerifyMutationVariables,
        TContext
      > => {
      return useMutation(getV1AuthOtpVerifyMutationOptions(options), queryClient);
    }
    export const getV1AuthOtpResendUrl = () => {




  return `/v1/auth/otp/resend`
}

/**
 * @summary Renvoyer le code : l'ancien est invalidé ; 60 s minimum entre deux envois
 */
export const v1AuthOtpResend = async (resendOtpRequest: ResendOtpRequest, options?: Parameters<typeof apiFetch>[1]): Promise<V1AuthOtpResend202> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<V1AuthOtpResend202>(getV1AuthOtpResendUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resendOtpRequest)
  }
);}





export const getV1AuthOtpResendMutationKey = () => ['v1AuthOtpResend'] as const;

export const getV1AuthOtpResendMutationOptions = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthOtpResend>>, TError,V1AuthOtpResendMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AuthOtpResend>>, TError,V1AuthOtpResendMutationVariables, TContext> => {

const mutationKey = getV1AuthOtpResendMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AuthOtpResend>>, V1AuthOtpResendMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  v1AuthOtpResend(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AuthOtpResendMutationResult = NonNullable<Awaited<ReturnType<typeof v1AuthOtpResend>>>
    export type V1AuthOtpResendMutationBody = ResendOtpRequest
    export type V1AuthOtpResendMutationError = ValidationExceptionResponse
    export type V1AuthOtpResendMutationVariables = {data: ResendOtpRequest}

    /**
 * @summary Renvoyer le code : l'ancien est invalidé ; 60 s minimum entre deux envois
 */
export const useV1AuthOtpResend = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthOtpResend>>, TError,V1AuthOtpResendMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AuthOtpResend>>,
        TError,
        V1AuthOtpResendMutationVariables,
        TContext
      > => {
      return useMutation(getV1AuthOtpResendMutationOptions(options), queryClient);
    }
    export const getV1AuthInvitationsResendUrl = () => {




  return `/v1/auth/invitations/resend`
}

/**
 * @summary Renvoyer l'email d'activation (ACC-P06 V3). Réponse identique que le compte existe ou non
 */
export const v1AuthInvitationsResend = async (resendInvitationRequest: ResendInvitationRequest, options?: Parameters<typeof apiFetch>[1]): Promise<V1AuthInvitationsResend202> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<V1AuthInvitationsResend202>(getV1AuthInvitationsResendUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resendInvitationRequest)
  }
);}





export const getV1AuthInvitationsResendMutationKey = () => ['v1AuthInvitationsResend'] as const;

export const getV1AuthInvitationsResendMutationOptions = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthInvitationsResend>>, TError,V1AuthInvitationsResendMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AuthInvitationsResend>>, TError,V1AuthInvitationsResendMutationVariables, TContext> => {

const mutationKey = getV1AuthInvitationsResendMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AuthInvitationsResend>>, V1AuthInvitationsResendMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  v1AuthInvitationsResend(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AuthInvitationsResendMutationResult = NonNullable<Awaited<ReturnType<typeof v1AuthInvitationsResend>>>
    export type V1AuthInvitationsResendMutationBody = ResendInvitationRequest
    export type V1AuthInvitationsResendMutationError = ValidationExceptionResponse
    export type V1AuthInvitationsResendMutationVariables = {data: ResendInvitationRequest}

    /**
 * @summary Renvoyer l'email d'activation (ACC-P06 V3). Réponse identique que le compte existe ou non
 */
export const useV1AuthInvitationsResend = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthInvitationsResend>>, TError,V1AuthInvitationsResendMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AuthInvitationsResend>>,
        TError,
        V1AuthInvitationsResendMutationVariables,
        TContext
      > => {
      return useMutation(getV1AuthInvitationsResendMutationOptions(options), queryClient);
    }
    export const getV1AuthInvitationsShowUrl = (token: string,) => {




  return `/v1/auth/invitations/${token}`
}

/**
 * @summary Invitation d'activation : données d'accueil de l'invité (ACC-P05). 410 si le lien n'est plus valide
 */
export const v1AuthInvitationsShow = async (token: string, options?: Parameters<typeof apiFetch>[1]): Promise<V1AuthInvitationsShow200> => {

  return apiFetch<V1AuthInvitationsShow200>(getV1AuthInvitationsShowUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1AuthInvitationsShowQueryKey = (token: string,) => {
    return [
    `/v1/auth/invitations/${token}`
    ] as const;
    }


export const getV1AuthInvitationsShowQueryOptions = <TData = Awaited<ReturnType<typeof v1AuthInvitationsShow>>, TError = unknown>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AuthInvitationsShow>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1AuthInvitationsShowQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1AuthInvitationsShow>>> = ({ signal }) => v1AuthInvitationsShow(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1AuthInvitationsShow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1AuthInvitationsShowQueryResult = NonNullable<Awaited<ReturnType<typeof v1AuthInvitationsShow>>>
export type V1AuthInvitationsShowQueryError = unknown


export function useV1AuthInvitationsShow<TData = Awaited<ReturnType<typeof v1AuthInvitationsShow>>, TError = unknown>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AuthInvitationsShow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AuthInvitationsShow>>,
          TError,
          Awaited<ReturnType<typeof v1AuthInvitationsShow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AuthInvitationsShow<TData = Awaited<ReturnType<typeof v1AuthInvitationsShow>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AuthInvitationsShow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AuthInvitationsShow>>,
          TError,
          Awaited<ReturnType<typeof v1AuthInvitationsShow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AuthInvitationsShow<TData = Awaited<ReturnType<typeof v1AuthInvitationsShow>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AuthInvitationsShow>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Invitation d'activation : données d'accueil de l'invité (ACC-P05). 410 si le lien n'est plus valide
 */

export function useV1AuthInvitationsShow<TData = Awaited<ReturnType<typeof v1AuthInvitationsShow>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AuthInvitationsShow>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1AuthInvitationsShowQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getV1AuthInvitationsAcceptUrl = (token: string,) => {




  return `/v1/auth/invitations/${token}/accept`
}

/**
 * @summary Activer son compte depuis l'invitation ; l'utilisateur est connecté
 */
export const v1AuthInvitationsAccept = async (token: string,
    acceptInvitationRequest: AcceptInvitationRequest, options?: Parameters<typeof apiFetch>[1]): Promise<V1AuthInvitationsAccept200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<V1AuthInvitationsAccept200>(getV1AuthInvitationsAcceptUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(acceptInvitationRequest)
  }
);}





export const getV1AuthInvitationsAcceptMutationKey = () => ['v1AuthInvitationsAccept'] as const;

export const getV1AuthInvitationsAcceptMutationOptions = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthInvitationsAccept>>, TError,V1AuthInvitationsAcceptMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AuthInvitationsAccept>>, TError,V1AuthInvitationsAcceptMutationVariables, TContext> => {

const mutationKey = getV1AuthInvitationsAcceptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AuthInvitationsAccept>>, V1AuthInvitationsAcceptMutationVariables> = (props) => {
          const {token,data} = props ?? {};

          return  v1AuthInvitationsAccept(token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AuthInvitationsAcceptMutationResult = NonNullable<Awaited<ReturnType<typeof v1AuthInvitationsAccept>>>
    export type V1AuthInvitationsAcceptMutationBody = AcceptInvitationRequest
    export type V1AuthInvitationsAcceptMutationError = ValidationExceptionResponse
    export type V1AuthInvitationsAcceptMutationVariables = {token: string;data: AcceptInvitationRequest}

    /**
 * @summary Activer son compte depuis l'invitation ; l'utilisateur est connecté
 */
export const useV1AuthInvitationsAccept = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthInvitationsAccept>>, TError,V1AuthInvitationsAcceptMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AuthInvitationsAccept>>,
        TError,
        V1AuthInvitationsAcceptMutationVariables,
        TContext
      > => {
      return useMutation(getV1AuthInvitationsAcceptMutationOptions(options), queryClient);
    }
    export const getV1AuthTwoFactorChallengeUrl = () => {




  return `/v1/auth/two-factor/challenge`
}

/**
 * @summary ACC-P02 — valider le second facteur (code reçu, code de l'application ou code de secours) : la session web est
ouverte, ou le jeton de l'appareil émis si la connexion venait de POST /auth/tokens
 */
export const v1AuthTwoFactorChallenge = async (twoFactorChallengeRequest: TwoFactorChallengeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<V1AuthTwoFactorChallenge200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<V1AuthTwoFactorChallenge200>(getV1AuthTwoFactorChallengeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(twoFactorChallengeRequest)
  }
);}





export const getV1AuthTwoFactorChallengeMutationKey = () => ['v1AuthTwoFactorChallenge'] as const;

export const getV1AuthTwoFactorChallengeMutationOptions = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthTwoFactorChallenge>>, TError,V1AuthTwoFactorChallengeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AuthTwoFactorChallenge>>, TError,V1AuthTwoFactorChallengeMutationVariables, TContext> => {

const mutationKey = getV1AuthTwoFactorChallengeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AuthTwoFactorChallenge>>, V1AuthTwoFactorChallengeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  v1AuthTwoFactorChallenge(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AuthTwoFactorChallengeMutationResult = NonNullable<Awaited<ReturnType<typeof v1AuthTwoFactorChallenge>>>
    export type V1AuthTwoFactorChallengeMutationBody = TwoFactorChallengeRequest
    export type V1AuthTwoFactorChallengeMutationError = ValidationExceptionResponse
    export type V1AuthTwoFactorChallengeMutationVariables = {data: TwoFactorChallengeRequest}

    /**
 * @summary ACC-P02 — valider le second facteur (code reçu, code de l'application ou code de secours) : la session web est
ouverte, ou le jeton de l'appareil émis si la connexion venait de POST /auth/tokens
 */
export const useV1AuthTwoFactorChallenge = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthTwoFactorChallenge>>, TError,V1AuthTwoFactorChallengeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AuthTwoFactorChallenge>>,
        TError,
        V1AuthTwoFactorChallengeMutationVariables,
        TContext
      > => {
      return useMutation(getV1AuthTwoFactorChallengeMutationOptions(options), queryClient);
    }
    export const getV1AuthTwoFactorResendUrl = () => {




  return `/v1/auth/two-factor/resend`
}

/**
 * @summary ACC-P02 « Renvoyer le code » (canal email) : l'ancien code est invalidé ; 60 s minimum entre deux envois
 */
export const v1AuthTwoFactorResend = async (twoFactorResendRequest: TwoFactorResendRequest, options?: Parameters<typeof apiFetch>[1]): Promise<V1AuthTwoFactorResend200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<V1AuthTwoFactorResend200>(getV1AuthTwoFactorResendUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(twoFactorResendRequest)
  }
);}





export const getV1AuthTwoFactorResendMutationKey = () => ['v1AuthTwoFactorResend'] as const;

export const getV1AuthTwoFactorResendMutationOptions = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthTwoFactorResend>>, TError,V1AuthTwoFactorResendMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AuthTwoFactorResend>>, TError,V1AuthTwoFactorResendMutationVariables, TContext> => {

const mutationKey = getV1AuthTwoFactorResendMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AuthTwoFactorResend>>, V1AuthTwoFactorResendMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  v1AuthTwoFactorResend(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AuthTwoFactorResendMutationResult = NonNullable<Awaited<ReturnType<typeof v1AuthTwoFactorResend>>>
    export type V1AuthTwoFactorResendMutationBody = TwoFactorResendRequest
    export type V1AuthTwoFactorResendMutationError = ValidationExceptionResponse
    export type V1AuthTwoFactorResendMutationVariables = {data: TwoFactorResendRequest}

    /**
 * @summary ACC-P02 « Renvoyer le code » (canal email) : l'ancien code est invalidé ; 60 s minimum entre deux envois
 */
export const useV1AuthTwoFactorResend = <TError = ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthTwoFactorResend>>, TError,V1AuthTwoFactorResendMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AuthTwoFactorResend>>,
        TError,
        V1AuthTwoFactorResendMutationVariables,
        TContext
      > => {
      return useMutation(getV1AuthTwoFactorResendMutationOptions(options), queryClient);
    }
    export const getV1AuthLogoutUrl = () => {




  return `/v1/auth/logout`
}

/**
 * @summary Déconnexion : ferme la session web ou supprime le jeton de l'appareil (ACC-02)
 */
export const v1AuthLogout = async ( options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getV1AuthLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getV1AuthLogoutMutationKey = () => ['v1AuthLogout'] as const;

export const getV1AuthLogoutMutationOptions = <TError = AuthenticationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthLogout>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AuthLogout>>, TError,void, TContext> => {

const mutationKey = getV1AuthLogoutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AuthLogout>>, void> = () => {


          return  v1AuthLogout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof v1AuthLogout>>>

    export type V1AuthLogoutMutationError = AuthenticationExceptionResponse


    /**
 * @summary Déconnexion : ferme la session web ou supprime le jeton de l'appareil (ACC-02)
 */
export const useV1AuthLogout = <TError = AuthenticationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AuthLogout>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AuthLogout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getV1AuthLogoutMutationOptions(options), queryClient);
    }
